import {defaultDataIdFromObject, StoreObject} from '@apollo/client';

import GraphQLIntrospectionResult from 'graphql-client/schema/GraphQLIntrospectionResult';
import {typeIsAbstract} from 'graphql-client/schema/util/SchemaOps';

const CONFIG_INTERFACE_NAME = 'AnalyticsParameterConfigInterface';
const CONFIG_ABSTRACT_TYPENAMES = GraphQLIntrospectionResult.__schema.types.filter((t) => typeIsAbstract(t));
const CONFIG_TYPENAMES = CONFIG_ABSTRACT_TYPENAMES.find(
  (type) => type.name === CONFIG_INTERFACE_NAME
)!.possibleTypes.map((type) => type.name);

/**
 * Return Apollo cache identifier for Analytics objects where we want to customize it. Otherwise, return
 * undefined.
 */
export default function dataIdFromAnalyticsObject(responseObject: Readonly<StoreObject>): string | undefined {
  if (responseObject.__typename && CONFIG_TYPENAMES.includes(responseObject.__typename)) {
    // PROBLEM: When a config changes type (like from STRING to DATE), its typename changes from
    // AnalyticsParameterStringConfigNode to AnalyticsParameterDateConfigNode. That means its cache
    // identifier changes from 'AnalyticsParameterStringConfigNode:apc_7cM2Fwpz' to
    // 'AnalyticsParameterDateConfigNode:apc_7cM2Fwpz', and Apollo thinks it's a different object even though
    // it's the same object.
    //
    // SOLUTION: Map all config type names to AnalyticsParameterConfigInterface. When the config changes type,
    // its cache identifier remains 'AnalyticsParameterConfigInterface:apc_7cM2Fwpz'.
    return defaultDataIdFromObject({__typename: CONFIG_INTERFACE_NAME, id: responseObject.id});
  }
  return undefined;
}
